// extracted by mini-css-extract-plugin
module.exports = {"section":"TermsModal_section__2gEGk","website":"TermsModal_website__2L-SA"};